import { useCallback, useState } from "react";
import { isSchoolSearchActive } from "../utils/schoolSearch";

/**
 * Query state for left-panel school search (list filtering, not a dropdown).
 */
export function useSchoolSearch() {
  const [query, setQuery] = useState("");

  const clear = useCallback(() => setQuery(""), []);
  const isActive = isSchoolSearchActive(query);

  return { query, setQuery, clear, isActive };
}
